import {AbstractModel} from "./abstract-model";

export class Gtm extends AbstractModel {
  id: number | null = null;
  containerId: string | null = null;

  override toString(): string {
    return this.containerId ?? '';
  }
}
